import React  from "react";
import { useParams } from 'react-router-dom';
import RegisteredAnimalsForm from "./components/RegisteredAnimalsForm";

const EditRegisteredAnimal = () => {
	const { registeredanimalId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<RegisteredAnimalsForm recordId={registeredanimalId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditRegisteredAnimal;